
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 80 80"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#15B85A","d":"M64 14h-5.43a6 6 0 00-6 6v39.88a6 6 0 006 6H64a6 6 0 006-6V20a6 6 0 00-6-6z"}}),_c('path',{attrs:{"fill":"#16D165","d":"M40.72 24.02h-5.44a6 6 0 00-6 6v29.86a6 6 0 006 6h5.44a6 6 0 006-6V30.02a6 6 0 00-6-6z"}}),_c('path',{attrs:{"fill":"#7DFCB3","d":"M17.43 35.39H12a6 6 0 00-6 6v18.49a6 6 0 006 6h5.43a6 6 0 006-6v-18.5a6 6 0 00-6-6z"}})])
          )
        }
      }
    